var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"animated fadeIn"},[_vm._t("before-pills"),_vm._l((_vm.items),function(item,index){return _c('context-pill',{key:index,attrs:{"disabled":item.disabled,"variant":item.variant,"to":item.to,"onClick":item.onClick,"onHover":item.onHover,"faIcon":item.faIcon,"label":item.label}})}),_vm._t("after-pills")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }